/**
 *  @class
 *  @function MaxHeight
 */
if (!customElements.get('max-height')) {
  class MaxHeight extends HTMLElement {
    constructor() {
      super();
      this.content = this.querySelector('.max-height--inner-content');
      this.toggle = this.querySelector('.max-height--toggle');
      this.max = parseInt(this.dataset.max) || 0;
      this.isInitialized = false;
    }
    
    connectedCallback() {
      this.toggle.addEventListener('click', this.onClick.bind(this));
      window.addEventListener('resize', this.checkVisible.bind(this));
      
      // Multiple initialization attempts
      this.initializeWithDelay();
    }
    
    initializeWithDelay() {
      // Try immediate check
      this.checkVisible();
      
      // Fallback checks with delays
      setTimeout(() => this.checkVisible(), 0);
      setTimeout(() => this.checkVisible(), 10);
      setTimeout(() => this.checkVisible(), 100);
      
      // Check when page is fully loaded
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', () => this.checkVisible());
      }
      
      // Check when all resources are loaded
      if (document.readyState !== 'complete') {
        window.addEventListener('load', () => this.checkVisible());
      }
      
      // Use requestAnimationFrame for better timing
      requestAnimationFrame(() => {
        requestAnimationFrame(() => this.checkVisible());
      });
    }
    
    checkVisible() {
      // Ensure content exists and has dimensions
      if (!this.content || !this.max) return;
      
      // Get computed height instead of offsetHeight for better accuracy
      const contentHeight = this.getContentHeight();
      
      if (contentHeight > this.max) {
        this.showToggle();
        this.isInitialized = true;
      } else if (contentHeight > 0) { // Only hide if we have actual content
        this.hideToggle();
        this.isInitialized = true;
      }
    }
    
    getContentHeight() {
      // Try multiple methods to get accurate height
      const offsetHeight = this.content.offsetHeight;
      const scrollHeight = this.content.scrollHeight;
      const computedStyle = window.getComputedStyle(this.content);
      const computedHeight = parseFloat(computedStyle.height);
      
      // Return the most reliable height value
      return Math.max(offsetHeight, scrollHeight, computedHeight || 0);
    }
    
    showToggle() {
      if (!this.classList.contains('max-height--active')) {
        this.classList.add('max-height--active');
      }
    }
    
    hideToggle() {
      this.classList.remove('max-height--active');
    }
    
    onClick() {
      this.classList.toggle('max-height--enabled');
    }
  }
  
  customElements.define('max-height', MaxHeight);
}

// if (!customElements.get('max-height')) {
//   class MaxHeight extends HTMLElement {
//     constructor() {
//       super();
//       this.content = this.querySelector('.max-height--inner-content');
//       this.toggle = this.querySelector('.max-height--toggle');
//       this.max = this.dataset.max;
//     }

//     connectedCallback() {
//       this.toggle.addEventListener('click', this.onClick.bind(this));
//       window.addEventListener('resize', this.checkVisible.bind(this));


//       this.checkVisible();
//     }

//     checkVisible() {
//       if (this.content.offsetHeight > this.max) {
//         this.showToggle();
//       } else {
//         this.hideToggle();
//       }
//     }
//     showToggle() {
//       this.classList.add('max-height--active');
//     }
//     hideToggle() {
//       this.classList.remove('max-height--active');
//     }
//     onClick() {
//       this.classList.toggle('max-height--enabled');
//     }
//   }
//   customElements.define('max-height', MaxHeight);
// }